export const paymentStatusTypes = {
    success: 'Complete',
    cancel: 'Cancelled',
    failure: 'failure',
    pending: 'pending',
    error: 'error'
};